import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-auth-menu',
    imports: [CommonModule, MatMenuModule, MatButtonModule, MatTooltipModule],
    templateUrl: './auth-menu.component.html',
    styleUrls: ['./auth-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthMenuComponent implements OnInit {
  @Input() name: string | undefined;
  @Input() email = '';

  initials = '';

  constructor(private authService: MsalService) {}

  ngOnInit(): void {
    this.initials = this.getInitialsFromName(this.name);
  }

  logout() {
    this.authService.logoutRedirect({
      postLogoutRedirectUri: '/login',
    });
  }

  private getInitialsFromName(name: string | undefined): string {
    if (!name) {
      return 'FU'; // what's the matter? this stands for "Fixation User"
    }

    const names = name.split(' ');

    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }

    return (
      names[0].charAt(0).toUpperCase() +
      names[names.length - 1].charAt(0).toUpperCase()
    );
  }
}
